import { createUseStyles } from 'react-jss'
import config from 'styles/config'

const { boxMobileMargin, boxMargin } = config.dimensions

const catalogStyles = (theme) => ({
  container: {
    margin: -boxMobileMargin
  },
  [config.mediaQueries.tabletPortrait]: {
    container: {
      margin: `-${boxMobileMargin}px -${boxMargin}px`
    }
  },
  box: {
    borderLeft: 0,
    borderRight: 0,
    borderTop: 0,
    marginBottom: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    '&:last-child': {
      borderBottom: 0
    }
  },
  catalog: {
    marginBottom: 0
  }
})

export default createUseStyles(catalogStyles)
